import React, { useState } from "react";
export default (props) => {
  const { children } = props;
  const [loading, setLoading] = useState(false);
  if (typeof children === "function") {
    return children(loading, setLoading);
  }
  return children;
};
